import React from 'react';
import { CreateReport } from '../../../components';
import { paths } from '../../../routes';
import * as Yup from 'yup';

export const AvitaillementForms: React.FC = () => {
  return (
    <CreateReport
      themeShortCode={paths.avitaillement.themeShortCode || ''}
      otherFields={{
        'fieldReportsDto.provisioning.urgentNeed': {
          type: 'switch',
          label: "Besoin d'avitaillement URGENT",
          grid: 12,
        },
        'fieldReportsDto.provisioning.nbrBottlesBoard': {
          type: 'input-range',
          label: 'Nombre de bouteilles à bord',
          grid: 6,
        },
        'fieldReportsDto.provisioning.nbrBottlesDistributed': {
          type: 'input-range',
          label: 'Nombre de bouteilles distribuées',
          grid: 6,
        },
        'fieldReportsDto.comment': {
          type: 'text',
          name: 'fact',
          label: 'Exposer les faits',
          multiline: true,
          rows: 4,
          rowsMax: 15,
        },
      }}
      validationSchema={Yup.object({
        serviceName: Yup.string().required('Ce champ est requis').nullable(),
      })}
    />
  );
};

export default AvitaillementForms;
